var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgStar = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 284,
    height: 284,
    viewBox: "0 0 284 284",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M186.3 209.8C185.2 209.8 184 209.5 183 209L142.4 187.7L101.8 209C99.4 210.3 96.5 210 94.3 208.5C92.1 206.9 91 204.2 91.5 201.5L99.2 156.2L66.3 124.2C64.4 122.3 63.6 119.5 64.5 117C65.4 114.5 67.5 112.6 70.2 112.2L115.6 105.6L136 64.6C138.4 59.8 146.4 59.8 148.8 64.6L169.1 105.7L214.5 112.3C217.2 112.7 219.4 114.6 220.2 117.1C221.1 119.6 220.3 122.6 218.4 124.3L185.5 156.3L193.2 201.6C193.7 204.3 192.6 206.9 190.4 208.6C189.2 209.4 187.8 209.8 186.3 209.8ZM86.6 124.2L111.8 148.8C113.4 150.4 114.2 152.7 113.8 155.1L107.8 189.9L139 173.5C141 172.4 143.6 172.4 145.6 173.5L176.8 189.9L170.8 155.1C170.4 152.8 171.2 150.4 172.8 148.8L198 124.2L163.1 119.1C160.8 118.7 158.8 117.3 157.8 115.2L142.2 83.6L126.6 115.2C125.6 117.4 123.6 118.8 121.3 119.1L86.6 124.2Z",
    fill: "black"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgStar, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/star.ceed37af.svg";
export { ForwardRef as ReactComponent };